/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { GbcarApiConfiguration as __Configuration } from '../gbcar-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { VisitorDto } from '../models/visitor-dto';
@Injectable({
  providedIn: 'root',
})
class ExternalVisitorService extends __BaseService {
  static readonly postApiExternalVisitorPath = '/api/ExternalVisitor';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param body undefined
   * @return Success
   */
  postApiExternalVisitorResponse(body?: VisitorDto): __Observable<__StrictHttpResponse<VisitorDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/ExternalVisitor`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<VisitorDto>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  postApiExternalVisitor(body?: VisitorDto): __Observable<VisitorDto> {
    return this.postApiExternalVisitorResponse(body).pipe(
      __map(_r => _r.body as VisitorDto)
    );
  }
}

module ExternalVisitorService {
}

export { ExternalVisitorService }
